import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", title: "Discover", copy: "We discuss your business, goals, audience and what you want your website to accomplish." },
  { n: "02", title: "Plan", copy: "We define the pages, sections, functionality, visual direction and project scope." },
  { n: "03", title: "Build", copy: "I create the website and develop the agreed functionality with a focus on responsive design and usability." },
  { n: "04", title: "Refine", copy: "You review the first draft and provide feedback. The website is refined through the agreed revision rounds." },
  { n: "05", title: "Launch", copy: "Once everything is approved and the project is complete, the website is prepared for final deployment." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="bg-surface border-y border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal>
          <div className="flex items-baseline gap-4">
            <span className="font-heading text-xl text-accent">04</span>
            <Eyebrow>The Process</Eyebrow>
          </div>
          <h2 className="mt-6 font-heading font-medium tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-ink">
            From idea to launch.
          </h2>
        </Reveal>

        <ol className="mt-14 md:mt-20">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <li
                data-testid={`process-step-${s.n}`}
                className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline border-b border-line py-8 md:py-10"
              >
                <span className="col-span-2 md:col-span-1 font-heading text-2xl md:text-3xl text-ink/25 group-hover:text-accent transition-colors duration-500">
                  {s.n}
                </span>
                <h3 className="col-span-10 md:col-span-3 font-heading text-3xl md:text-4xl font-medium uppercase tracking-tight text-ink">
                  {s.title}
                </h3>
                <p className="col-span-12 md:col-span-8 text-base leading-relaxed text-stone max-w-2xl md:pl-6">
                  {s.copy}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={0.1}>
          <p data-testid="process-note" className="mt-8 text-sm text-stone/80 italic max-w-2xl">
            Initial working drafts are typically provided within approximately one week,
            depending on project requirements and receipt of the necessary materials.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
